module.exports = __webpack_public_path__ + "static/media/was-ist.316bc499.png";